import styled from 'styled-components';

const SetPasswordTextWrapper = styled.div`
  margin-bottom: 20px;
`;

const SetPasswordStyleWrapper = styled.div`
  padding: 40px;

  .set-password-input {
    .ant-form-item-label {
      color: red;
      font-size: var(--font-size-small);
      line-height: var(--font-line-height-medium);
      margin: 0 2px 0 10px;
      padding: 0;

      label {
        margin: 0;
      }
    }
  }

  .set-password-button-wrapper {
    display: flex;

    button {
      width: 100%;
    }
  }
`;

export { SetPasswordStyleWrapper, SetPasswordTextWrapper };
